module.exports = __webpack_public_path__ + "media/assets/images/category/Easter@2x-6fdeede4a09309babb605ea18d400953.png";